import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { APIConstants } from '../../../../_config/restapis';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { $DBManagerService } from '../../../../_helpers/DB/DBManager.service';
import { Constants } from '../../../../_utils/Constants';
import { $BroadcastManagerService } from '../../../../_helpers/BroadcastManager.service';

@Injectable()
export class APIHelpdeskService {

    constructor(
        private http: HttpClient,
        private db: $DBManagerService,
        private evt: $BroadcastManagerService
    ) { }

    public requestRegistration(data): Observable<any> {
        return this.http.post(APIConstants.REQUESTREGISTRATION, data);
    }
    public getRequestsData(data): Observable<any> {
        return this.http.post(APIConstants.GETREQUESTSDATA, data);
    }
    public requestsWorklistfilter(data): Observable<any> {
        return this.http.post(APIConstants.REQUESTSWORKLISTFILTER, data);
    }
    public requestResolution(data): Observable<any> {
        return this.http.post(APIConstants.REQUESTRESOLUTION, data);
    }


    
}







